import * as React from "react";

/**
 * Properties used to prevent an element from being dragged.
 */
export const preventDrag = {
  onKeyDown: (evt: React.KeyboardEvent) => evt.stopPropagation(),
  onPointerDown: (evt: React.PointerEvent) => evt.stopPropagation(),
};
